<template>
    <div class="fm-container">
        <Backer class="hidden-print" v-if="showbacker != false"/>
        <div>
            <div class="hidden-print">
                <b-alert show variant="success" style="padding:10px !important; margin-top: 10px; margin-bottom: 10px; font-size: 17px;">
                    <div v-if="invoice.invoice_id == null">
                        <b>New Sale</b>
                    </div>
                    <div v-else>
                        <b>INVOICE # {{ invoice.invoice_id }}</b>
                    </div>
                </b-alert>
            </div>

            <b-overlay :show="invoice_being_loaded" rounded="sm">
                <div style="margin-top: 10px;">
                    <!--invoice information-->
                    <b-card>
                        <!-- <div style="font-size: 20px;">Invoice Information</div> -->
                        <div>
                            <span style="display: inline-block; margin: 10px; width: auto;">
                                <b-card-text>
                                    <span>Date:</span>
                                    <span> {{ invoice.ts }}  </span>
                                </b-card-text>
                            </span>

                            <span style="display: inline-block; margin: 10px; width: auto;">
                                <b-card-text>
                                    <span>User:</span>
                                    <span> {{ (invoice.username || userDetails.username ) }}  </span>
                                </b-card-text>
                            </span>

                            <span style="display: inline-block; margin: 10px;">
                                <b-card-text>
                                    <span>Location:</span>

                                    <span v-if="userDetails.userrole == 'admin'">
                                        <span style="display: inline-block; margin: 5px;">
                                            <b-form-select
                                                value-field="value"
                                                text-field="text"
                                                :options="locations"
                                                v-model="invoice.location_id"
                                                size="sm"
                                            ></b-form-select>
                                        </span>

                                        <span style="display: inline-block; margin: 5px;" v-if="invoice.location_id != null">
                                            <b-form-select
                                                value-field="value"
                                                text-field="text"
                                                :options="sublocations.filter(function(d){return d.location_id == invoice.location_id && d.sublocation_type_id == 1 })"
                                                v-model="invoice.sublocation_id"
                                                size="sm"
                                            ></b-form-select>
                                        </span>
                                    </span>
                                    <span v-else>
                                        <span style="display: inline-block; margin: 5px;">{{ locationsdict[invoice.location_id] }}</span>

                                        <span style="display: inline-block; margin: 5px;" v-if="invoice.location_id != null">
                                            <b-form-select
                                                value-field="value"
                                                text-field="text"
                                                :options="sublocations.filter(function(d){return d.location_id == invoice.location_id && d.sublocation_type_id == 1 })"
                                                v-model="invoice.sublocation_id"
                                                size="sm"
                                            ></b-form-select>
                                        </span>
                                    </span>
                                </b-card-text>
                            </span>

                            <span style="display: inline-block;" v-if="invoice.sublocation_id != null">
                                <span v-show="invoice.sublocation_id != null" style="display: inline-block;  width: auto; background: #efefef; padding: 10px; border: 1px dashed black; ">
                                    <b-card-text>
                                        <span> Grand Total:</span>
                                        <span> $ {{ (getGrandTotal()).toFixed(2) }}  </span>
                                    </b-card-text>
                                </span>
                            </span>

                        </div>
                    </b-card>
                </div>

                <div style="margin-top: 10px;">
                    <div v-if="invoice.sublocation_id != null">
                        <!--customer information-->
                        <b-card header="Customer Info" style="margin-top: 10px;">
                            <b-form autocomplete="off">
                                <div>
                                    
                                    <b-form-group
                                        description="We'll never share your email with anyone else."
                                        style="display: inline-block; max-width: 300px; vertical-align: top;"
                                    >
                                        <label>Email<sup style="color: crimson;">*</sup></label>
                                        <b-form-input
                                            v-model="invoice.customer.email"
                                            type="email"
                                            placeholder="Enter email"
                                            style=""
                                            autocomplete="off"
                                        ></b-form-input>
                                    </b-form-group>


                                    <b-form-group
                                        description=""
                                        style="display: inline-block; max-width: 300px; vertical-align: top; "
                                    >
                                        <label>Name<sup style="color: crimson;">*</sup></label>
                                        <b-form-input
                                            id="input-1"
                                            v-model="invoice.customer.firstname"
                                            type="text"
                                            placeholder="Enter name"
                                            style=""
                                            autocomplete="off"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>

                                <div>
                                    <b-form-group
                                        description=""
                                        style="display: inline-block; max-width: 300px; vertical-align: top; "
                                    >
                                        <label>Phone # 1<sup style="color: crimson;">*</sup></label>
                                        <b-form-input
                                            v-model="invoice.customer.phone"
                                            placeholder="Enter primary phone"
                                            style=""
                                            autocomplete="off"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        description=""
                                        style="display: inline-block; max-width: 300px; vertical-align: top; "
                                    >
                                        <label>Phone # 2</label>
                                        <b-form-input
                                            v-model="invoice.customer.phone_2"
                                            type="text"
                                            placeholder="Enter second phone"
                                            style=""
                                            autocomplete="off"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>

                                <div>
                                    <b-form-group
                                        description=""
                                        style="display: inline-block; width: 40%; max-width: 300px; vertical-align: top;"
                                    >
                                        <label>Address<sup style="color: crimson;">*</sup></label>
                                        <b-form-input
                                            v-model="invoice.customer.address"
                                            type="text"
                                            placeholder="Enter address"
                                            style=""
                                            autocomplete="off"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        description=""
                                        style="display: inline-block; min-width: 30px; max-width: 50px; vertical-align: top; "
                                    >
                                        <label>Apt</label>
                                        <b-form-input
                                            v-model="invoice.customer.apt"
                                            type="text"
                                            placeholder="Apt"
                                            style=""
                                            autocomplete="off"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        id="input-group-1"
                                        description=""
                                        style="display: inline-block; min-width: 30px; max-width: 50px; vertical-align: top;"
                                    >
                                        <label>Flr</label>
                                        <b-form-input
                                            id="input-1"
                                            v-model="invoice.customer.floor"
                                            type="text"
                                            placeholder="Flr"
                                            style=""
                                            autocomplete="off"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        description=""
                                        style="display: inline-block; min-width: 100px; max-width: 100px; vertical-align: top;"
                                    >
                                        <label>Zipcode<sup style="color: crimson;">*</sup></label>
                                        <b-form-input
                                            id="input-1"
                                            v-model="invoice.customer.zipcode"
                                            type="text"
                                            placeholder="Zipcode"
                                            style=""
                                            autocomplete="off"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        description=""
                                        style="display: inline-block; min-width: 100px; max-width: 100px; vertical-align: top;"
                                    >
                                        <label>City</label>
                                        <b-form-input
                                            id="input-1"
                                            v-model="invoice.customer.city"
                                            type="text"
                                            placeholder="City"
                                            style=""
                                            autocomplete="off"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                            </b-form>
                        </b-card>

                        <!--products-->
                        <b-card header="Products" style="margin-top: 10px; min-width: 20rem;">
                            <b-card-group deck>
                                <b-card
                                    v-for="item, idx in invoice.items"
                                    no-body
                                    style="min-width: 20rem; max-width: 500px; margin: 10px;"
                                    img-src=""
                                    img-alt="Image"
                                    border-variant="info"
                                    img-top
                                    v-bind:key="product_sku"
                                  >
                                    <!-- <template v-slot:header>
                                        {{item.product_sku}}
                                    </template> -->

                                    <b-card-body>
                                        <div>
                                            <b-input-group prepend="SKU"  style="margin: 5px;" size="sm">
                                                
                                                <b-form-input 
                                                v-model="item.product_sku" 
                                                style="font-weight: bold;"
                                                :disabled="!item.is_special"
                                                ></b-form-input>
                                               
                                            </b-input-group>

                                            <b-input-group prepend="Product"  style="margin: 5px;" size="sm">
                                                
                                                <b-form-input 
                                                v-model="item.product_name" 
                                                style=""
                                                :disabled="!item.is_special"
                                                ></b-form-input>
                                               
                                            </b-input-group>

                                            <b-input-group prepend="Price ($)"  style="margin: 5px;" size="sm">
                                                
                                                <b-form-input 
                                                v-model="item.selling_price" 
                                                style=""
                                                :disabled="!item.is_special"
                                                ></b-form-input>
                                               
                                            </b-input-group>

                                            <b-input-group prepend="Vendor"  style="margin: 5px;" size="sm">
                                                <b-form-input 
                                                v-model="item.product_vendor" 
                                                style=""
                                                :disabled="!item.is_special"
                                                ></b-form-input>
                                            </b-input-group>

                                            <b-input-group prepend="Category"  style="margin: 5px;" size="sm">
                                                <b-form-input 
                                                v-model="item.product_category" 
                                                style=""
                                                :disabled="!item.is_special"
                                                ></b-form-input>
                                            </b-input-group>

                                            <b-input-group prepend="Quantity"  style="margin: 5px; width: 120px;" size="sm">
                                                <b-form-input 
                                                v-model="item.quantity" 
                                                style="background: yellow; "
                                                
                                                ></b-form-input>
                                            </b-input-group>

                                            <b-input-group prepend="Discount ($)" style="margin: 5px;" size="sm">
                                                <b-form-input 
                                                v-model="item.discount_offered" 
                                                style=""
                                                :disabled="invoice.invoice_id != null"
                                                ></b-form-input>
                                            </b-input-group>

                                            <b-input-group prepend="Order Type" style="margin: 5px;" size="sm">
                                                <b-form-select
                                                    v-model="item.order_type"
                                                    :options="order_types"
                                                    size="sm"
                                                    style="font-size: 15px;"
                                                    
                                                ></b-form-select>
                                            </b-input-group>

                                            <b-input-group prepend="Pickup Date" v-if="item.order_type == 'store_pickup' " style="margin: 5px;" size="sm">
                                                <b-form-datepicker 
                                                    reset-button
                                                    style=""
                                                    size="sm" placeholder="" v-model="item.pickup_date"  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en-US" :date-disabled-fn="dateDisabled"> 
                                                </b-form-datepicker>
                                            </b-input-group>

                                            <b-input-group prepend="Delivery Date" v-if="item.order_type == 'home_delivery' " style="margin: 5px;" size="sm">
                                                <b-form-datepicker 
                                                    reset-button
                                                    style=""
                                                    size="sm" placeholder="" v-model="item.delivery_date"  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en-US" :date-disabled-fn="dateDisabled"> 
                                                </b-form-datepicker>
                                            </b-input-group>

                                        </div>

                                        <div style="width: 100%; text-align: left; padding: 5px;">
                                        <b-button size="sm" variant="dark" @click="removeItem(idx)" class="hidden-print">Remove</b-button>
                                        </div>
                                    </b-card-body>
                                    <!-- <b-card-footer>Item Total: ${{ getItemTotal(idx) }}</b-card-footer> -->
                                </b-card>
                                <!-- <b-card :header="item.product_sku" v-for="item, idx in invoice.items" style="margin: 10px; width: 100%;">
                                    <div>
                                        <b-card-sub-title style="font-size: 13px; font-weight: bold;">{{ item.product_name }}</b-card-sub-title>
                                    </div>
                                    
                                    <div style="margin-top: 10px;">
                                        <table style="width: 100%;">
                                            <tr>
                                                <td class="ipt_tdr">
                                                    Product
                                                </td>
                                                <td class="ipt_tdr">
                                                    <span v-if="item.is_special == false">
                                                        {{item.product_name}} ( {{item.product_sku}} )
                                                    </span>
                                                    <span v-else>

                                                        <b-input size="sm" style="font-size: 13px; margin-bottom: 10px;" v-model="item.product_name" placeholder="Enter product name"></b-input>

                                                        <b-input size="sm" style="font-size: 13px; margin-bottom: 10px;" v-model="item.product_sku" placeholder="Enter product sku"></b-input>

                                                        <b-form-select
                                                            v-model="item.product_vendor"
                                                            :options="vendors"
                                                            size="sm"
                                                            style="font-size: 13px; margin-bottom: 10px;"
                                                            
                                                        ></b-form-select>
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="ipt_tdr">
                                                    Price ($)
                                                </td>
                                                <td class="ipt_tdr">
                                                    ${{ (item.selling_price) }}
                                                </td>
                                            </tr>
                                            <tr>
                                                 <td class="ipt_tdr">
                                                    Quantity
                                                </td>
                                                <td class="ipt_tdr">
                                                    <div style="">
                                                        <b-input size="sm" style="max-width: 80px; width: auto; background: yellow; font-size: 13px; margin: auto;" v-model="item.quantity"></b-input>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="ipt_tdr">
                                                    Discount ($)
                                                </td>
                                                <td class="ipt_tdr">
                                                    <div style="">
                                                        <b-input size="sm" style="max-width: 80px; width: auto; font-size: 13px; margin: auto;" v-model="item.discount_offered"></b-input>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="ipt_tdr">
                                                    Order Type
                                                </td>
                                                <td class="ipt_tdr">
                                                    <div>
                                                        <b-form-select
                                                            v-model="item.order_type"
                                                            :options="order_types"
                                                            size="sm"
                                                            style="max-width: 150px; width: auto; font-size: 13px;"
                                                            
                                                        ></b-form-select>
                                                    </div>

                                                    <b-card-text style="font-size: 13px; background: #efefef; padding: 5px; margin: 5px;" v-if="item.order_type == 'store_pickup'">
                                                        <div style="">Pickup Date:</div>
                                                        <b-form-datepicker 
                                                            reset-button
                                                            style="font-size: 13px; width: auto; max-width: 200px; margin: auto;"
                                                            size="sm" placeholder="" v-model="item.pickup_date"  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en-US" :date-disabled-fn="dateDisabled"> 
                                                        </b-form-datepicker>
                                                    </b-card-text>
                                                    
                                                    <b-card-text style="font-size: 13px; background: #efefef; padding: 5px; margin: 5px;" v-if="item.order_type == 'home_delivery'">
                                                        <div style="">Delivery Date:</div>
                                                        <b-form-datepicker 
                                                            reset-button
                                                            style="font-size: 13px; width: auto; max-width: 200px; margin: auto;"
                                                            size="sm" placeholder="" v-model="item.delivery_date"  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en-US" :date-disabled-fn="dateDisabled"> 
                                                        </b-form-datepicker>
                                                    </b-card-text>

                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="ipt_tdr">
                                                    Item Total ($)
                                                </td>
                                                <td class="ipt_tdr">
                                                    <b>{{ getItemTotal(idx) }}</b>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                    <div style="margin-top: 10px;">
                                        <b-button size="sm" variant="outline-dark" @click="removeItem(idx)" class="hidden-print">Remove</b-button>
                                    </div>
                                </b-card> -->
                            </b-card-group>

                            <div class="hidden-print" style="margin-top: 10px; padding: 10px; background: #f2f2f2;">
                                <vue-bootstrap-typeahead
                                    class="mb-4"
                                    v-model="product_query"
                                    :data="filtered_products"
                                    :serializer="s => s.product_sku + ' ('+s.product_name+')' "
                                    :max-matches="1000"
                                    @hit="current_product = $event"
                                    placeholder="Search Products"
                                    style="width: 100%; max-width: 300px; display: inline-block; font-size: 14px;"
                                />

                                <b-button size="sm" variant="outline-primary" @click="add_new_product({is_special: false})" class="hidden-print">Add Product</b-button>

                                <b-button size="sm" variant="outline-dark" @click="add_new_product({is_special: true})" class="hidden-print">Add Special Product</b-button>
                            </div>

                        </b-card>

                        <b-card header="Summary" style="margin-top: 10px;">
                            <b-card style="margin: 10px; width: 100%;">
                                <table style="width: 100%;">
                                    <tr>
                                        <td class="ipt_tdr">
                                            Delivery Fees ($)
                                        </td>
                                        <td class="ipt_tdr">
                                            <b-input size="sm" style="max-width: 80px; width: auto; background: yellow; margin: auto;" v-model="invoice.delivery_charges"></b-input>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="ipt_tdr">
                                            Total Warranty ($)
                                        </td>
                                        <td class="ipt_tdr">
                                            <b-input size="sm" style="max-width: 80px; width: auto; background: yellow; margin: auto;" v-model="invoice.warranty_charges"></b-input>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="ipt_tdr">
                                            Setup Fees ($)
                                        </td>
                                        <td class="ipt_tdr">
                                            <b-input size="sm" style="max-width: 80px; width: auto; background: yellow; margin: auto;" v-model="invoice.setup_charges"></b-input>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="ipt_tdr">
                                            <b>Total Discounts ($)</b>
                                        </td>
                                        <td class="ipt_tdr">
                                            {{ (getTotalDiscount()).toFixed(2) }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="ipt_tdr">
                                            Order Total ($)
                                        </td>
                                        <td class="ipt_tdr">
                                            {{ (getOrderTotal()).toFixed(2) }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="ipt_tdr">
                                            Total Charges ($)
                                        </td>
                                        <td class="ipt_tdr">
                                            {{ (getChargesTotal()).toFixed(2) }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="ipt_tdr">
                                            Subtotal ($)
                                        </td>
                                        <td class="ipt_tdr">
                                            {{ (getSubTotal()).toFixed(2) }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="ipt_tdr">
                                            Sales Tax ($)
                                        </td>
                                        <td class="ipt_tdr">
                                            +{{ (getSalesTax()).toFixed(2) }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="ipt_tdr">
                                            <b>Grand Total ($)</b>
                                        </td>
                                        <td class="ipt_tdr" style="background: yellow;">
                                            <b>{{  (getGrandTotal()).toFixed(2) }}</b>
                                        </td>
                                    </tr>

                                    
                                </table>
                            </b-card>
                        </b-card>

                        <b-card header="Payment Methods" style="margin-top: 10px;">

                            <b-card-group deck>
                                <b-card 
                                    v-for="payment_method, pmidx in invoice.payment_methods" 
                                    style="margin: 10px; width: 100%; max-width: 400px;"
                                    border-variant="info"
                                    :header="payment_method.value"
                                    
                                    align="center"
                                    v-bind:key="value"
                                >
                                    <table style="">
                                        <!-- <thead v-show="invoice.payment_methods[pmidx].value != null">
                                            <th style="background: black; color: white; padding: 5px; border: 1px solid black;">
                                               {{ invoice.payment_methods[pmidx].value  }}
                                            </th>
                                        </thead> -->
                                        <tbody>
                                            <tr>
                                                <td class="ipt_tdr">
                                                    Payment Method
                                                </td>
                                                <td class="ipt_tdr">
                                                    <b-form-select
                                                        value-field="value"
                                                        text-field="text"
                                                        :options="payment_method_options"
                                                        v-model="invoice.payment_methods[pmidx].value"
                                                        size="sm"
                                                    ></b-form-select>
                                                </td>
                                            </tr>
                                            <tr v-if="invoice.payment_methods[pmidx].value">
                                                <td class="ipt_tdr">
                                                    Amount ($)
                                                </td>
                                                <td class="ipt_tdr">
                                                    <b-input type="number" size="sm" autocomplete="off" v-model="invoice.payment_methods[pmidx].amount" style="width: 100px; display: absolute;"></b-input>
                                                </td>
                                            </tr>

                                            <tr v-show="invoice.payment_methods[pmidx].value == 'finance'">
                                                <td class="ipt_tdr">
                                                    Finance Company
                                                </td>
                                                <td class="ipt_tdr">
                                                    <b-form-select
                                                        value-field="value"
                                                        text-field="text"
                                                        :options="finance_companies"
                                                        v-model="invoice.payment_methods[pmidx].finance_company"
                                                        size="sm"
                                                    ></b-form-select>
                                                </td>
                                            </tr>

                                            <tr v-if="invoice.payment_methods[pmidx].value == 'finance'">
                                                <td class="ipt_tdr">
                                                    Lease ID
                                                </td>
                                                <td class="ipt_tdr">
                                                    <b-input type="text" size="sm" autocomplete="off" v-model="invoice.payment_methods[pmidx].lease_id" style=""></b-input>
                                                </td>
                                            </tr>

                                            <tr v-if="invoice.payment_methods[pmidx].value == 'finance' && invoice.payment_methods[pmidx].finance_company != null && invoice.payment_methods[pmidx].finance_company != undefined ">
                                                <td class="ipt_tdr">
                                                    Contact #
                                                </td>
                                                <td class="ipt_tdr">
                                                   {{ finance_companies.filter(function(d){return d.value == invoice.payment_methods[pmidx].finance_company})[0].phone_number }}
                                                </td>
                                            </tr>

                                            <tr v-if="invoice.payment_methods[pmidx].value == 'finance'">
                                                <td class="ipt_tdr">
                                                    ACCT#/ETC.
                                                </td>
                                                <td class="ipt_tdr">
                                                    <b-input type="text" size="sm" autocomplete="off" v-model="invoice.payment_methods[pmidx].misc_info" style=""></b-input>
                                                </td>
                                            </tr>

                                            <tr v-if="invoice.payment_methods[pmidx].value == 'finance'">
                                                <td class="ipt_tdr">
                                                    Other Info.
                                                </td>
                                                <td class="ipt_tdr">
                                                    <b-input type="text" size="sm" autocomplete="off" v-model="invoice.payment_methods[pmidx].other_infi" style=""></b-input>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div style="text-align: left;">
                                        <b-badge size="sm" variant="danger" @click="removePaymentMethod(pmidx)" style="cursor: pointer; padding: 5px;">Remove</b-badge>
                                    </div>
                                </b-card>
                            </b-card-group>

                            <div style="margin-top: 10px;">
                                <b-button size="sm" variant="outline-primary" @click="addPaymentMethod">Add</b-button>
                            </div>
                        </b-card>
                    </div>
                </div>


                <div style="margin-top: 10px; padding: 10px; text-align: center;">
                    <div v-if="!invoice.invoice_id">
                        <b-button variant="success" size="sm" @click="submitInvoice">Submit</b-button>
                    </div>
                    <div v-else>
                        <b-button variant="success" size="sm" @click="submitInvoice">Update</b-button>
                    </div>
                </div>


            </b-overlay>

            <b-modal id="modal-availability" scrollable title="" size="md" hide-footer>
                <Availability :viewdata="{availability_data:availability_data, product_id: q_product_id, product_sku: q_product_sku}" :locationsdict="locationsdict" :sublocationsdict="sublocationsdict" />
            </b-modal>
        </div>
    </div>
</template>


<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import Availability from '@/components/importables/Availability'
    import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'
    import moment from 'moment'

    export default {
        name: "NewSales",
        props: ["showbacker"],
        components: {Backer,VueGoodTable,Multiselect,Availability,VueBootstrapTypeahead},

        data: function(){
            let out = {
                show_add_products: false,
                userDetails: {properties: {}},
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict:  {},
                vendors: [],
                vendorsdict: {},
                search_keyword: null,
                block_search: false,
                searched_products: [],
                all_loc_inventory_dict: {},
                locsubs:[],
                special_product: {},
                payment_method_options: [
                    {value: "cc", text: "Credit Card"},
                    {value: "cash", text: "Cash"},
                    {value: "finance", text: "Finance"},
                    // {value: "layaway", text: "Lay Away"},
                ],
                finance_companies: [
                    {value: "SNAP FINANCE", text: "SNAP FINANCE", phone_number: "1-877-557-3769"},
                    {value: "U-OWN LEASING", text: "U-OWN LEASING", phone_number: "1-877-353-8696"},
                    {value: "PREFERRED LEASE", text: "PREFERRED LEASE", phone_number: "1-770-575-5980"},
                    {value: "ACIMA CREDIT", text: "ACIMA CREDIT", phone_number: "1-801-297-1926"},
                    {value: "KORNERSTONE CREDIT", text: "KORNERSTONE CREDIT", phone_number: "1-888-521-5111"},
                    {value: "SYNCHRONY", text: "SYNCHRONY", phone_number: "1-800-677-0718"},
                    {value: "EASY PAY FINANCE", text: "EASY PAY FINANCE", phone_number: "1-866-337-2537"},
                    {value: "GREAT AMERICAN FINANCE", text: "GREAT AMERICAN FINANCE", phone_number: "1-866-944-2326"},
                ],
                order_types: [
                    {"value": "customer_takes", "text": "Take Home"},
                    {"value": "store_pickup", "text": "Store Pickup"},
                    {"value": "home_delivery", "text": "Home Delivery"},
                ],
                block_post_invoice: false,
                invoice_being_loaded: false,
                availability_data: [],
                q_product_id: null,
                q_product_sku: null,
                minimum_sell_threshold: 5,
                product_query: null,
                products: [
                    // {product_sku: "abc", product_id: 123, product_name: "ABC BONANZE", text: ""},
                    // {product_sku: "xza", product_id: 456, product_name: "XZA BONANT", text: ""},
                    // {product_sku: "xzap PP", product_id: 456, product_name: "XZAP BNT", text: ""},
                    // {product_sku: "vj-1000_90", product_id: 456, product_name: "VJJ ashhd 1092"},
                ],
                filtered_products: [],
                current_product: {},
            };

            out.invoice =  {
                ts: Requestor.moment(),
                invoice_id: null,
                username: null, 
                customer: {
                    firstname: null,
                    lastname: null,
                    email: null,
                    phone: null,
                    phone_2: null,
                    address: null,
                    floor: null,
                    apt: null,
                    city: null,
                    zipcode: null,
                },
                items: [],
                delivery_charges: 0,
                setup_charges: 0,
                warranty_charges: 0,
                payment_methods: [],
                location_id: null,
                sublocation_id: null,
                sales_tax: 0.0,
            };
            return out;
        },
        watch: {
            product_query(new_product_query) {
                let that = this;
                this.filtered_products = this.products.filter(item => {
                    return (
                        ( 
                        item.product_name.toLowerCase().indexOf(that.product_query.toLowerCase()) > -1
                        ||
                        item.product_sku.toLowerCase().indexOf(that.product_query.toLowerCase()) > -1
                        )
                    );
                })
            }
        },
        methods: {
            add_new_product: function(param){
                let is_special = param.is_special;
                

                if (!this.current_product && !is_special){
                    return 
                }
                let item = {
                    product_id: ((is_special) ? -1 : this.current_product.product_id),
                    product_name: this.current_product.product_name,
                    product_sku: this.current_product.product_sku,
                    product_vendor: this.current_product.vendor,
                    product_category: this.current_product.category,
                    quantity: null,
                    selling_price: this.current_product.selling_price,
                    discount_offered: 0.0,
                    children: [],
                    is_special: is_special,
                    order_type: null,
                    pickup_date: null,
                    delivery_date: null,
                    location_id: this.location_id,
                    sublocation_id: this.sublocation_id,
                    source_location_id: null,
                    source_sublocation_id: null
                }
                this.invoice.items.push(item);
                this.current_product = {};
                this.product_query = "";
            },
            submitInvoice: function(e) {
                if (e) {
                    e.preventDefault();
                }
                let invoice = this.invoice;
                invoice.warranty_charges = (+invoice.warranty_charges || 0.0);
                invoice.delivery_charges = (+invoice.delivery_charges || 0.0);
                invoice.setup_charges = (+invoice.setup_charges || 0.0);
                invoice.sales_tax = this.getSalesTax();

                //val # 1: confirm that user details are not empty
                let customer_error = this.validate_customer_info(invoice.customer);
                if (customer_error.length > 0){
                    this.$vex.dialog.alert({message: customer_error[0]})
                    return
                }

                //val # 2: confirm that products are not empty + product quanties are valid
                let products_error = this.validate_products(invoice.items);
                if (products_error.length > 0){
                    this.$vex.dialog.alert({message: products_error[0]})
                    return
                }

                //val # 3: confirm that the amounts specified in payment methods do add up the grand total.
                let payments_error = this.validate_payment_methods(invoice.payment_methods);
                if (payments_error.length > 0){
                    this.$vex.dialog.alert({message: payments_error[0]})
                    return
                }
                invoice.payment_methods = invoice.payment_methods.map(function(d){
                    d.amount = (+d.amount || 0.0); return d;
                });

                let that = this;
                let path = "/api/sales/record_sale/"
                if (invoice.invoice_id){
                    path = "/api/sales/update_sale/"
                }
                
                let data = invoice;
                data.username = this.userDetails.username;
                data.location_short = this.locations.filter(function(d){return d.value == data.location_id})[0].description;

                if (data.order_type == 'customer_takes'){
                    data.source_location_id = data.location_id;
                    data.source_sublocation_id = data.sublocation_id;
                }

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        //this means its a new sale
                        if (!that.invoice.invoice_id){
                            let invoice_id = response.data.result.invoice_id;
                            if (invoice_id){
                                that.$router.push({path: "/sales/view_invoice/"+invoice_id+"/"});
                            }
                        }
                        else {
                            that.$bvToast.toast(
                                "Updated Invoice", 
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );
                        }
                        
                    }
                    that.block_post_invoice=false;
                }

                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "An error occurred while registering sale. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.block_post_invoice=false;
                }
                this.block_post_invoice = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            getSubTotal: function(){
                let order_total = this.getOrderTotal();
                let total_charges = this.getChargesTotal();
                return (order_total + total_charges);
            },
            getItemTotal: function(idx){
                let item = this.invoice.items[idx];
                let sp = (+item.selling_price || 0.0);
                let qty = (+item.quantity || 1.0);
                let dsc = (+item.discount_offered || 0.0);
                return ( (sp*qty) - dsc ).toFixed(2);
            },
            getOrderTotal: function(){
                var k = 0.0;
                for (var i =0; i<this.invoice.items.length; i++){
                    let sp = (+this.invoice.items[i].selling_price || 0.0);
                    let qty = (+this.invoice.items[i].quantity || 1.0);
                    let dsc = (+this.invoice.items[i].discount_offered || 0.0);

                    k += ( (sp*qty) - dsc );
                }
                return k;

            },
            getChargesTotal: function(){
                let dlv = (+this.invoice.delivery_charges || 0.0);
                let stp = (+this.invoice.setup_charges || 0.0);
                let wtp = (+this.invoice.warranty_charges || 0.0);
                return (dlv + stp + wtp);
            },
            getSalesTax: function(){
                let total_charges = this.getChargesTotal();
                let order_total = this.getOrderTotal();
                let perc = 0.10;
                return (order_total + total_charges) * perc;
            },
            getTotalDiscount: function(){
                var k = 0.0;
                for (var i =0; i<this.invoice.items.length; i++){
                    let dsc = (+this.invoice.items[i].discount_offered || 0.0);
                    k += dsc;
                }
                return k;
            },
            getGrandTotal: function(){
                let order_total = this.getOrderTotal();
                let total_charges = this.getChargesTotal();
                let sales_tax = this.getSalesTax();
                return (order_total + total_charges + sales_tax) * 1.0;
            },
            
            addPaymentMethod: function(e){
                if (e){
                    e.preventDefault();
                }

                let new_payment_method = {
                    value: null,
                    amount: 0.0,
                    properties: {}
                }
                this.invoice.payment_methods.push(new_payment_method);
            },
            
            
            removeItem: function(idx){
                this.invoice.items.splice(idx, 1);
            },
            removePaymentMethod: function(pmidx){
                this.invoice.payment_methods.splice(pmidx, 1);
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/user/get_tools_packet/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.locations.map(function(d){
                                    return {value: d.id, text: d.name, description: d.description}
                                });
                                
                                if (that.userDetails){
                                    if (that.userDetails.properties){
                                        if (that.userDetails.properties.location_id){
                                            let location_id = that.userDetails.properties.location_id;

                                            that.locations = that.locations.filter(function(d){return d.value == location_id });
                                            that.invoice.location_id = location_id;
                                        }
                                    }
                                }

                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});

                                that.sublocations = response.data.result.sublocations.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id, sublocation_type_id: d.sublocation_type_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                                that.vendors = response.data.result.vendors.map(function(d){
                                    return {value: d.value, text: d.text}
                                });
                                that.vendorsdict = that.vendors.reduce((map, obj) => (map[obj.value] = obj.text, map), {});

                                that.locsubs = response.data.result.locsubs;
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/product/get_products_for_sale/",
                        data: {},
                        type: "secure",
                        executable: Requestor.getSyncP,
                        s: function(response){
                            if (response.data.result){
                                that.products = response.data.result;
                                that.fetch_init();
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading products.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }
                
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);    
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
            fetch_init: function(){
                if (!(this.invoice.invoice_id)){
                    console.log("nothing to call here..")
                    return
                }
                let that = this;
                let path = "/api/sales/get_invoice/"
                let data = {invoice_id: this.invoice.invoice_id};                

                let s = function(response){
                    if (response.data.result){
                        that.invoice = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.invoice_being_loaded = false;
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading invoice data.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.invoice_being_loaded = false;
                }
                that.invoice_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            validate_customer_info: function(customer_information){
                let errors = [];
                if (!customer_information.firstname){
                    errors.push("Please enter customer name.")
                }
                if (!customer_information.email){
                    errors.push("Please enter customer email.")
                }
                if (!customer_information.phone){
                    errors.push("Please enter customer phone.")
                }
                if (!customer_information.zipcode){
                    errors.push("Please enter customer zipcode.")
                }

                return errors;
            },
            validate_products: function(products){
                let errors = []
                if (products.length <=0){
                    errors.push("No products added to the sale.");
                }
                if (products.map(function(d){return (d.quantity || 0)}).indexOf(0) >= 0 ){
                    errors.push("Product quantity should be > 0.");
                }

                for (var i=0; i<products.length; i++){
                    let pickup_date = products[i].pickup_date;
                    let delivery_date = products[i].delivery_date;
                    let order_type = products[i].order_type;

                    if (!order_type){
                        errors.push("Please indicate order type for all items.");
                    }

                    if (order_type == "store_pickup"){
                        if (!pickup_date){
                            errors.push("Missing store pickup date.");
                        }
                        else {
                            if (moment(pickup_date) < moment()){
                                errors.push("All pickup dates should be in future.")
                            }
                        }

                        products[i].delivery_date = undefined;
                        products[i] = JSON.parse(JSON.stringify(products[i]));

                    }

                    if (order_type == "home_delivery"){
                        if (!delivery_date){
                            errors.push("Missing delivery date.");
                        }
                        else {
                            if (moment(delivery_date) < moment()){
                                errors.push("All delivery dates should be in future.")       
                            }
                        }

                        products[i].pickup_date = undefined;
                        products[i] = JSON.parse(JSON.stringify(products[i]));
                    }

                    if (order_type == "customer_takes"){
                        products[i].pickup_date = undefined;
                        products[i].delivery_date = undefined;
                        products[i] = JSON.parse(JSON.stringify(products[i]));
                    }
                }
                return errors
            },
            validate_payment_methods: function(payment_methods){
                let errors = [];
                var s = 0;
                var gt = parseFloat(this.getGrandTotal().toFixed(2));
                for (var i=0; i<payment_methods.length; i++){
                    s += (parseFloat(payment_methods[i].amount) || 0.0);

                    if (payment_methods[i].value == "finance"){
                        if (!(payment_methods[i].lease_id)){
                            errors.push("All finance related sales should include their lease/finance id.")
                        }
                        if (!(payment_methods[i].finance_company)){
                            errors.push("All finance related sales should include their lease/finance company name.")
                        }
                    }
                }
                s = parseFloat(s.toFixed(2));
                gt = parseFloat(gt.toFixed(2));
                if (s < gt){
                    errors.push("Total payment amount should match the grand total.")
                }
                return errors
            },
            getItemAvailability: function(idx, container_name){
                let path = "/api/inventory/get_tr_item_availability/";

                var item;
                if (container_name == "searched_products"){
                    item = this.searched_products[idx];
                }
                else {
                    item = this.invoice.items[idx];
                }

                if (!item.product_sku){
                    this.$bvToast.toast(
                        "SKU not found.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }
                
                let data = {product_id: item.product_id, product_sku: item.product_sku};
                let that = this;
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.availability_data = response.data.result;
                        that.q_product_id = item.product_id;
                        that.q_product_sku = item.product_sku;
                        that.$bvModal.show("modal-availability");
                    }
                    
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "An error occurred trying to fetch product availability. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                Requestor.getAsync(path, data, s, f);
            },
            dateDisabled: function(ymd, date){
                return date <= moment()    
            },
        },
        created: function() {
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                this.invoice.invoice_id = this.$route.params.invoice_id;
                this.fetch_prereqs();
            }
        }
    }
</script>

<style scoped>

    .ipt_tdr {
        padding: 5px;
    }


</style>


// WEBPACK FOOTER //
// src/components/NewSales.vue